"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.panelNavigatorContextPropType = exports.ConsumesPanelNavigatorContext = exports.Provider = exports.Consumer = exports.types = void 0;

var _react = _interopRequireWildcard(require("react"));

var _consumerDecoratorFactory = _interopRequireDefault(require("./consumerDecoratorFactory"));

var types = {
  registerWidth: _react.PropTypes.func,
  getCurrentPanel: _react.PropTypes.func,
  renderNavigation: _react.PropTypes.func
};
exports.types = types;

var _React$createContext = _react.default.createContext({}),
    Consumer = _React$createContext.Consumer,
    Provider = _React$createContext.Provider;

exports.Provider = Provider;
exports.Consumer = Consumer;
var ConsumesPanelNavigatorContext = (0, _consumerDecoratorFactory.default)('panelNavigator', Consumer);
exports.ConsumesPanelNavigatorContext = ConsumesPanelNavigatorContext;

var panelNavigatorContextPropType = _react.PropTypes.shape(types);

exports.panelNavigatorContextPropType = panelNavigatorContextPropType;